<div class="maxContainerWidth">
    <div class="businessSlider">
        <h2 class="text-gradient">
            Business
        </h2>
        <div class="sliderWrap">
            <ngx-slick-carousel class="carousel" 
            #slickModal="slick-carousel" 
            [config]="slideConfig" 
            >
            
                <div ngxSlickItem class="slide" *ngFor="let blog of blogsList">
                    <div class="blogWrap">
                        <div class="blogImage">
                            <img src="assets/images/blog-listing/{{blog.imgSrc}}" alt="">
                        </div>
                        <div class="blogDate">
                            {{blog.date}}
                        </div>
                        <div class="blogTitle text-white">
                            {{blog.title}}
                        </div>
                        <div class="blogDescription">
                            {{blog.description}}
                        </div>
                    </div>
                </div>
           
</ngx-slick-carousel>
        </div>
    </div>
</div>